import { Refine, Authenticated } from '@refinedev/core'
import { BrowserRouter, Route, Routes, Outlet, Navigate } from 'react-router'
import routerProvider from '@refinedev/react-router'
import { Toaster } from 'sonner'
import { authProvider } from './providers/authProvider'
import { postgrestDataProvider } from './providers/dataProvider'
import { notificationProvider } from './providers/notificationProvider'
import { resources } from './resources'
import { AppLayout } from './components/layout/AppLayout'
import { DashboardPage } from './pages/dashboard'
import { ListPage } from './pages/resources/list'
import { CreatePage } from './pages/resources/create'
import { EditPage } from './pages/resources/edit'
import { ShowPage } from './pages/resources/show'
import { CreateAgencyPage } from './pages/custom/CreateAgency'
import { CreateGreenhouseApiKeyPage } from './pages/custom/CreateGreenhouseApiKey'
import { PartnerClientsPage } from './pages/custom/PartnerClients'
import { ServiceConfigurationPage } from './pages/custom/ServiceConfiguration'
import { CliOpsPage } from './pages/custom/CliOpsPage'
import { MessagingPage } from './pages/custom/MessagingPage'
import { ApprovalChainPage } from './pages/custom/ApprovalChainPage'
import { RoleTreePage } from './pages/custom/RoleTreePage'
import { LinkedinMonitoringPage } from './pages/custom/LinkedinMonitoring'
import { PermissionSeedPage } from './pages/custom/PermissionSeedPage'
import { SessionsPage } from './pages/custom/SessionsPage'
import { LoginPage } from './pages/login'

export default function App() {
  return (
    <BrowserRouter>
      <Toaster richColors position="top-right" />
      <Refine
        authProvider={authProvider}
        dataProvider={{ default: postgrestDataProvider }}
        routerProvider={routerProvider}
        notificationProvider={notificationProvider}
        resources={resources}
        options={{ syncWithLocation: true, warnWhenUnsavedChanges: true }}
      >
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <Authenticated key="auth" fallback={<Navigate to="/login" replace />}>
                <AppLayout><Outlet /></AppLayout>
              </Authenticated>
            }
          >
            <Route index element={<DashboardPage />} />
            {resources.map((resource) => (
              <Route key={resource.name} path={resource.name}>
                <Route index element={<ListPage resource={resource.name} />} />
                <Route path="create" element={<CreatePage resource={resource.name} />} />
                <Route path="edit/:id" element={<EditPage resource={resource.name} />} />
                <Route path="show/:id" element={<ShowPage resource={resource.name} />} />
              </Route>
            ))}
            <Route path="custom/create-agency" element={<CreateAgencyPage />} />
            <Route path="custom/create-greenhouse-api-key" element={<CreateGreenhouseApiKeyPage />} />
            <Route path="custom/partner-clients" element={<PartnerClientsPage />} />
            <Route path="custom/service-configuration" element={<ServiceConfigurationPage />} />
            <Route path="custom/cli-ops" element={<CliOpsPage />} />
            <Route path="custom/messaging" element={<MessagingPage />} />
            <Route path="custom/approval-chains" element={<ApprovalChainPage />} />
            <Route path="custom/role-tree" element={<RoleTreePage />} />
            <Route path="custom/linkedin-monitoring" element={<LinkedinMonitoringPage />} />
            <Route path="custom/permission-seed" element={<PermissionSeedPage />} />
            <Route path="custom/sessions" element={<SessionsPage />} />
          </Route>
        </Routes>
      </Refine>
    </BrowserRouter>
  )
}
